"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlotStateFactories = void 0;
const dragging_state_1 = require("./dragging-state");
const idle_state_1 = require("./idle-state");
const indeterminate_state_1 = require("./indeterminate-state");
const panning_state_1 = require("./panning-state");
const pinch_zooming_state_1 = require("./pinch-zooming-state");
/**
 * @public
 * {@inheritDoc IPlotStateFactories}
 */
class PlotStateFactories {
    getDraggingState(startEvent, options, providers, sharedState) {
        return new dragging_state_1.DraggingState(startEvent.clone(), options, providers, sharedState);
    }
    getIdleState(lastClick, options, providers, sharedState) {
        return new idle_state_1.IdleState(lastClick, options, providers, sharedState);
    }
    getIndeterminateState(downEvent, options, providers, sharedState, lastClick) {
        return new indeterminate_state_1.IndeterminateState(downEvent.clone(), options, providers, sharedState, lastClick);
    }
    getPanningState(startEvent, options, providers, sharedState) {
        return new panning_state_1.PanningState(startEvent.clone(), options, providers, sharedState);
    }
    getPinchZoomingState(firstDownFingerEvent, secondDownFingerEvent, options, providers, sharedState) {
        return new pinch_zooming_state_1.PinchZoomingState(firstDownFingerEvent.clone(), secondDownFingerEvent.clone(), options, providers, sharedState);
    }
}
exports.PlotStateFactories = PlotStateFactories;
//# sourceMappingURL=plot-state-factories.js.map